import React, { useEffect, useRef } from 'react';
import api from "../api/api";
import { appState } from "../redux/redux-config";

export default function OrgSwitcher() {
    const appAndOrgSwitcher = useRef();

    const fetchData = async () => {
        try {
            const token = appState().user.token;
            if (!token) {
                throw new Error('Token is not available');
            }

            const result = await api.user.getUserOrganizationDetails(token);
            const script = document.createElement('script');
            script.id = 'appAndOrgSwitcherScript';
            script.src = result.src;
            script.dataset.uuid = result.unityOrguuid;
            script.dataset.selected = 2;
            script.dataset.lang = 'en';
            script.dataset.fixed = 'true';
            script.dataset.haveRequiredFonts = 'true';
            appAndOrgSwitcher.current.appendChild(script);
        } catch (error) {
            console.error("Failed to load organization details", error);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);


    return (
        <div style={{ width: '104px', height: '65px' }}>
            <div ref={appAndOrgSwitcher}></div>  {/* This div will hold the dynamically added script */}
        </div>
    );
}
